
// English Names
export const enPeasantNames = [
    "John", "William", "Thomas", "Robert", "Richard", "Henry", "Geoffrey", "Walter", "Hugh", "Roger",
    "Mary", "Alice", "Matilda", "Agnes", "Margaret", "Joan", "Isabella", "Emma", "Beatrice", "Cecily"
];

export const enPeasantSurnames = [
    "Smith", "Miller", "Baker", "Carter", "Cooper", "Fletcher", "Wright", "Tailor", "Thatcher", "Weaver",
    "of the Wood", "of the Hill", "by the Water", "Underwood", "Field"
];

export const enNobleNames = [
    "Edward", "Richard", "Henry", "Charles", "William", "Arthur", "George", "Louis", "Philip", "James",
    "Eleanor", "Isabella", "Margaret", "Elizabeth", "Anne", "Mary", "Catherine", "Blanche", "Philippa", "Adela"
];

export const enNobleSurnames = [
    "Plantagenet", "Tudor", "Lancaster", "York", "Neville", "Percy", "Beaufort", "Mortimer", "De Clare", "De Warenne"
];

export const enKnightTitles = [
    "Sir", "Dame"
];

export const enKnightEpithets = [
    "the Brave", "the Bold", "the Lionhearted", "the Strong", "the Gallant", "the Loyal", "the Just", "the Fair",
    "of the Lake", "of the North", "of the Realm"
];

// Turkish Names (Seljuk/Ottoman style)
export const trPeasantNames = [
    "Ahmet", "Mehmet", "Mustafa", "Ali", "Hasan", "Hüseyin", "Yusuf", "İbrahim", "Osman", "Ömer",
    "Ayşe", "Fatma", "Hatice", "Zeynep", "Emine", "Meryem", "Elif", "Havva", "Sultan", "Esma"
];

export const trPeasantSurnames = [
    "Demir", "Yılmaz", "Kaya", "Şahin", "Çelik", "Yıldız", "Özdemir", "Arslan", "Doğan", "Kılıç"
];

export const trNobleNames = [
    "Osman", "Orhan", "Murad", "Bayezid", "Mehmed", "Selim", "Süleyman", "Selçuk", "Alaeddin", "Kılıç Arslan",
    "Hürrem", "Kösem", "Mihrimah", "Nurbanu", "Safiye", "Turhan", "Valide", "Hatice", "Beyhan", "Şah"
];

export const trNobleTitles = [
    "Bey", "Paşa", "Sultan", "Han", "Hakan", "Gazi"
];

export const trKnightNames = [
    "Alparslan", "Battal", "Danişmend", "Saltuk", "Artuk", "Tural", "Konur", "Bamsı", "Doğan", "Sungur"
];

export const trKnightEpithets = [
    "Alp", "Gazi", "Bahadır", "Yiğit", "Kara", "Deli", "Pehlivan", "Cengaver"
];


// French Names
export const frPeasantNames = [
    "Jean", "Pierre", "Michel", "Jacques", "Philippe", "Louis", "Henri", "Guillaume", "François", "Antoine",
    "Marie", "Jeanne", "Anne", "Catherine", "Marguerite", "Françoise", "Elisabeth", "Madeleine", "Nicole", "Louise"
];

export const frPeasantSurnames = [
    "Lefebvre", "Moreau", "Dubois", "Durand", "Leroy", "Roux", "Petit", "Boucher", "Meunier", "Charpentier"
];

export const frNobleNames = [
    "Louis", "Philippe", "Charles", "Henri", "François", "Jean", "Robert", "Hugues", "Gaston", "Raoul",
    "Aliénor", "Blanche", "Isabelle", "Marguerite", "Jeanne", "Anne", "Catherine", "Claude", "Renée", "Charlotte"
];

export const frNobleSurnames = [
    "de Valois", "de Bourbon", "d'Anjou", "de Blois", "de Champagne", "de Normandie", "d'Aquitaine", "de Toulouse", "de Foix", "de Montfort"
];

export const frKnightTitles = [
    "Chevalier", "Sire"
];

export const frKnightEpithets = [
    "le Brave", "le Hardi", "le Preux", "le Loyal", "le Juste", "le Grand", "le Bon", "le Téméraire",
    "du Lac", "de la Tour", "de la Croix"
];

// Spanish Names (Reconquista era)
export const esPeasantNames = [
    "Juan", "Pedro", "Diego", "Miguel", "Francisco", "Alfonso", "Fernando", "Gonzalo", "Rodrigo", "Sancho",
    "María", "Isabel", "Juana", "Teresa", "Catalina", "Leonor", "Beatriz", "Elvira", "Blanca", "Urraca"
];

export const esPeasantSurnames = [
    "Herrero", "Molinero", "Panadero", "Carpintero", "Tejedor", "Pastor", "Labrador", "Cantero", "Alfarero", "Zapatero"
];

export const esNobleNames = [
    "Alfonso", "Fernando", "Sancho", "Rodrigo", "Gonzalo", "Enrique", "Pedro", "Juan", "Carlos", "Felipe",
    "Isabel", "Leonor", "Urraca", "Berenguela", "Blanca", "María", "Juana", "Catalina", "Beatriz", "Constanza"
];

export const esNobleSurnames = [
    "de Castilla", "de León", "de Aragón", "de Navarra", "de Lara", "de Haro", "de Trastámara", "de Guzmán", "de Mendoza", "de Álvarez"
];

export const esKnightTitles = [
    "Don", "Doña"
];

export const esKnightEpithets = [
    "el Bravo", "el Valiente", "el Cid", "el Fuerte", "el Justo", "el Grande", "el Noble", "el Sabio",
    "de la Cruz", "de la Frontera", "del Río"
];

// German Names (Holy Roman Empire era)
export const dePeasantNames = [
    "Hans", "Friedrich", "Karl", "Wilhelm", "Heinrich", "Otto", "Ludwig", "Konrad", "Dietrich", "Albrecht",
    "Greta", "Hildegard", "Gertrud", "Mechthild", "Kunigunde", "Adelheid", "Brunhild", "Hedwig", "Irmgard", "Waltraud"
];

export const dePeasantSurnames = [
    "Schmied", "Müller", "Bäcker", "Wagner", "Weber", "Schäfer", "Fischer", "Zimmermann", "Schneider", "Gerber"
];

export const deNobleNames = [
    "Friedrich", "Otto", "Heinrich", "Karl", "Ludwig", "Konrad", "Albrecht", "Dietrich", "Siegfried", "Wilhelm",
    "Hildegard", "Mechthild", "Kunigunde", "Adelheid", "Brunhild", "Hedwig", "Gertrud", "Elisabeth", "Agnes", "Irmgard"
];

export const deNobleSurnames = [
    "von Habsburg", "von Hohenstaufen", "von Sachsen", "von Bayern", "von Schwaben", "von Brandenburg", "von Luxemburg", "von Wittelsbach", "von Wettin", "von Zähringen"
];

export const deKnightTitles = [
    "Ritter", "Freiherr"
];

export const deKnightEpithets = [
    "der Tapfere", "der Kühne", "der Starke", "der Gerechte", "der Große", "der Treue", "der Weise", "der Eiserne",
    "vom See", "vom Berg", "von der Burg"
];

// Portuguese Names (Reconquista era)
export const ptPeasantNames = [
    "João", "Pedro", "Afonso", "Nuno", "Fernão", "Diogo", "Álvaro", "Vasco", "Gil", "Martim",
    "Maria", "Teresa", "Leonor", "Isabel", "Beatriz", "Inês", "Branca", "Constança", "Filipa", "Catarina"
];

export const ptPeasantSurnames = [
    "Ferreiro", "Moleiro", "Padeiro", "Carpinteiro", "Tecelão", "Pastor", "Lavrador", "Canteiro", "Oleiro", "Sapateiro"
];

export const ptNobleNames = [
    "Afonso", "Sancho", "Dinis", "Fernando", "João", "Duarte", "Pedro", "Nuno", "Álvaro", "Vasco",
    "Teresa", "Mafalda", "Leonor", "Isabel", "Beatriz", "Filipa", "Inês", "Branca", "Constança", "Catarina"
];

export const ptNobleSurnames = [
    "de Borgonha", "de Avis", "de Bragança", "de Meneses", "de Castro", "de Sousa", "de Melo", "de Almeida", "de Pereira", "de Noronha"
];

export const ptKnightTitles = [
    "Cavaleiro", "Senhor"
];

export const ptKnightEpithets = [
    "o Bravo", "o Valente", "o Forte", "o Justo", "o Grande", "o Nobre", "o Sábio", "o Leal",
    "do Lago", "da Torre", "da Cruz"
];

// Arabic Names (Medieval Islamic era)
export const arPeasantNames = [
    "أحمد", "محمد", "علي", "حسن", "حسين", "عمر", "خالد", "سعيد", "إبراهيم", "يوسف",
    "فاطمة", "عائشة", "خديجة", "زينب", "مريم", "أسماء", "حفصة", "رقية", "أم كلثوم", "سكينة"
];

export const arPeasantSurnames = [
    "الحداد", "النجار", "الخياط", "الحائك", "البنّاء", "الصباغ", "الدبّاغ", "القصاب", "الطحّان", "الفخّار"
];

export const arNobleNames = [
    "صلاح الدين", "هارون", "المأمون", "المعتصم", "نور الدين", "بيبرس", "قطز", "الظاهر", "المنصور", "الرشيد",
    "شجر الدر", "خاتون", "زبيدة", "بران", "ست الملك", "رضية", "عالية", "سلطانة", "أميرة", "ملكة"
];

export const arNobleTitles = [
    "السلطان", "الأمير", "الملك", "الوزير", "الخليفة", "القائد"
];

export const arKnightNames = [
    "خالد", "طارق", "صلاح", "عنتر", "سيف", "حمزة", "أسامة", "معاذ", "بلال", "سعد"
];

export const arKnightEpithets = [
    "المجاهد", "الفاتح", "المظفر", "الغازي", "البطل", "الأسد", "السيف", "الصاعقة"
];

// Hindi Names (Rajput/Mughal era)
export const hiPeasantNames = [
    "राम", "श्याम", "गोपाल", "मोहन", "लक्ष्मण", "भरत", "कृष्ण", "हरि", "देव", "सुरेश",
    "सीता", "गीता", "राधा", "लक्ष्मी", "पार्वती", "सरस्वती", "दुर्गा", "कमला", "सावित्री", "अनुसूया"
];

export const hiPeasantSurnames = [
    "लोहार", "कुम्हार", "जुलाहा", "बढ़ई", "चमार", "तेली", "माली", "धोबी", "नाई", "ग्वाला"
];

export const hiNobleNames = [
    "महाराणा", "पृथ्वीराज", "अकबर", "शिवाजी", "राणा", "भोज", "विक्रमादित्य", "अशोक", "चंद्रगुप्त", "समुद्रगुप्त",
    "पद्मावती", "रानी", "देवी", "जोधा", "रूपमती", "चाँदबीबी", "अहिल्या", "लक्ष्मीबाई", "दुर्गावती", "कर्णावती"
];

export const hiNobleTitles = [
    "महाराजा", "राजा", "नवाब", "सुल्तान", "सम्राट", "बादशाह"
];

export const hiKnightNames = [
    "वीर", "प्रताप", "अमर", "बहादुर", "रण", "योद्धा", "भीम", "अर्जुन", "द्रोण", "कर्ण"
];

export const hiKnightEpithets = [
    "वीर", "महावीर", "रणबीर", "शूरवीर", "योद्धा", "बहादुर", "प्रतापी", "अजेय"
];

// Japanese Names (Sengoku/Samurai era)
export const jaPeasantNames = [
    "太郎", "次郎", "三郎", "四郎", "五郎", "六郎", "七郎", "八郎", "九郎", "十郎",
    "花", "梅", "桜", "菊", "雪", "月", "春", "夏", "秋", "冬"
];

export const jaPeasantSurnames = [
    "田中", "山本", "中村", "小林", "加藤", "佐藤", "鈴木", "高橋", "伊藤", "渡辺"
];

export const jaNobleNames = [
    "信長", "秀吉", "家康", "謙信", "信玄", "政宗", "幸村", "義経", "頼朝", "清盛",
    "濃姫", "茶々", "お市", "まつ", "千代", "北条政子", "細川ガラシャ", "巴御前", "静御前", "常盤御前"
];

export const jaNobleSurnames = [
    "織田", "豊臣", "徳川", "上杉", "武田", "伊達", "真田", "源", "平", "北条"
];

export const jaKnightTitles = [
    "侍", "武士"
];

export const jaKnightEpithets = [
    "剣聖", "鬼神", "軍神", "猛将", "勇将", "名将", "智将", "豪傑",
    "一刀流", "二刀流", "無双"
];

// Korean Names (Joseon/Goryeo era)
export const koPeasantNames = [
    "철수", "영수", "민수", "준호", "성호", "동수", "광수", "재호", "상호", "정수",
    "영희", "미영", "순이", "옥순", "말순", "춘자", "영자", "명자", "정순", "복순"
];

export const koPeasantSurnames = [
    "김", "이", "박", "최", "정", "강", "조", "윤", "장", "임"
];

export const koNobleNames = [
    "세종", "이순신", "을지문덕", "강감찬", "광개토", "태조", "정조", "세조", "성종", "영조",
    "선덕", "진덕", "진성", "혜경", "인수", "명성", "인현", "장희빈", "사임당", "허난설헌"
];

export const koNobleSurnames = [
    "이", "왕", "김", "박", "최", "정", "윤", "한", "송", "유"
];

export const koKnightTitles = [
    "장군", "무사"
];

export const koKnightEpithets = [
    "충무공", "무적", "용맹", "호국", "의로운", "강철", "천하무쌍", "백전불패",
    "청룡", "백호", "현무"
];

// Indonesian Names (Majapahit/Srivijaya era)
export const idPeasantNames = [
    "Wayan", "Made", "Nyoman", "Ketut", "Bagus", "Putu", "Kadek", "Komang", "Agus", "Dewa",
    "Ni", "Dewi", "Sri", "Ayu", "Luh", "Gusti", "Dayu", "Desak", "Sagung", "Anak"
];

export const idPeasantSurnames = [
    "Pandai", "Tukang", "Petani", "Nelayan", "Pande", "Undagi", "Jero", "Panjak", "Pasek", "Bendesa"
];

export const idNobleNames = [
    "Hayam Wuruk", "Gajah Mada", "Airlangga", "Ken Arok", "Raden", "Prabu", "Sri Baduga", "Jayanegara", "Tribhuwana", "Kertanegara",
    "Tribhuwana", "Suhita", "Gayatri", "Ken Dedes", "Dyah Pitaloka", "Ratu Shima", "Pramodhawardhani", "Dewi Sartika", "Nyi Ageng", "Ratu Kalinyamat"
];

export const idNobleTitles = [
    "Raja", "Prabu", "Sultan", "Adipati", "Patih", "Senopati"
];

export const idKnightNames = [
    "Gatotkaca", "Bima", "Arjuna", "Karna", "Abimanyu", "Antareja", "Hanoman", "Nakula", "Sadewa", "Werkudara"
];

export const idKnightEpithets = [
    "Perkasa", "Sakti", "Bijaksana", "Agung", "Mulia", "Gagah", "Pemberani", "Tangguh"
];

// Vietnamese Names (Ly/Tran/Le dynasty era)
export const viPeasantNames = [
    "An", "Bình", "Cường", "Dũng", "Em", "Phúc", "Gia", "Hùng", "Khoa", "Lâm",
    "Mai", "Ngọc", "Oanh", "Phương", "Quỳnh", "Thanh", "Uyên", "Vân", "Xuân", "Yến"
];

export const viPeasantSurnames = [
    "Thợ Rèn", "Thợ Mộc", "Thợ Dệt", "Nông Dân", "Ngư Dân", "Thợ Gốm", "Thợ May", "Tiều Phu", "Bác Sĩ", "Thầy Đồ"
];

export const viNobleNames = [
    "Lý Thái Tổ", "Trần Nhân Tông", "Lê Lợi", "Quang Trung", "Đinh Tiên Hoàng", "Lý Thường Kiệt", "Trần Hưng Đạo", "Nguyễn Huệ", "Lê Thánh Tông", "Gia Long",
    "Ỷ Lan", "Trưng Trắc", "Trưng Nhị", "Bà Triệu", "Ngọc Hân", "Huyền Trân", "Liễu Hạnh", "Ngọc Vạn", "Từ Dũ", "Nam Phương"
];

export const viNobleTitles = [
    "Vua", "Hoàng Đế", "Đại Vương", "Chúa", "Quốc Công", "Thái Sư"
];

export const viKnightNames = [
    "Hùng", "Dũng", "Mạnh", "Cường", "Kiệt", "Chiến", "Thắng", "Phong", "Quang", "Minh"
];

export const viKnightEpithets = [
    "Đại Tướng", "Vô Địch", "Anh Hùng", "Hào Kiệt", "Nghĩa Sĩ", "Dũng Sĩ", "Chiến Thần", "Bất Bại"
];

// Russian Names (Kievan Rus/Medieval era)
export const ruPeasantNames = [
    "Иван", "Пётр", "Василий", "Фёдор", "Григорий", "Алексей", "Дмитрий", "Николай", "Степан", "Тимофей",
    "Мария", "Анна", "Ольга", "Елена", "Татьяна", "Наталья", "Екатерина", "Варвара", "Евдокия", "Прасковья"
];

export const ruPeasantSurnames = [
    "Кузнецов", "Мельников", "Плотников", "Гончаров", "Ткачёв", "Пастухов", "Рыбаков", "Сапожников", "Кожевников", "Бочаров"
];

export const ruNobleNames = [
    "Владимир", "Ярослав", "Святослав", "Игорь", "Олег", "Александр", "Дмитрий", "Иван", "Борис", "Всеволод",
    "Ольга", "Анна", "Евпраксия", "Рогнеда", "Елизавета", "Мария", "Ирина", "Евфросиния", "Агафья", "Соломония"
];

export const ruNobleSurnames = [
    "Рюрикович", "Мономах", "Невский", "Долгорукий", "Мудрый", "Грозный", "Годунов", "Шуйский", "Оболенский", "Трубецкой"
];

export const ruKnightTitles = [
    "Витязь", "Богатырь"
];

export const ruKnightEpithets = [
    "Храбрый", "Могучий", "Непобедимый", "Грозный", "Славный", "Удалой", "Железный", "Мудрый",
    "Донской", "Невский", "Тверской"
];

// Italian Names (Renaissance/Medieval era)
export const itPeasantNames = [
    "Giovanni", "Marco", "Antonio", "Francesco", "Lorenzo", "Giuseppe", "Luca", "Andrea", "Pietro", "Paolo",
    "Maria", "Anna", "Caterina", "Lucia", "Francesca", "Elena", "Chiara", "Rosa", "Teresa", "Giovanna"
];

export const itPeasantSurnames = [
    "Fabbro", "Mugnaio", "Fornaro", "Sarto", "Tessitore", "Pastore", "Contadino", "Pescatore", "Calzolaio", "Vasaio"
];

export const itNobleNames = [
    "Lorenzo", "Cosimo", "Federico", "Ludovico", "Galeazzo", "Giovanni", "Carlo", "Filippo", "Roberto", "Alfonso",
    "Lucrezia", "Caterina", "Isabella", "Beatrice", "Bianca", "Eleonora", "Giulia", "Vittoria", "Chiara", "Matilde"
];

export const itNobleSurnames = [
    "de' Medici", "Sforza", "Visconti", "Borgia", "d'Este", "Gonzaga", "Colonna", "Orsini", "Malatesta", "della Scala"
];

export const itKnightTitles = [
    "Cavaliere", "Messere"
];

export const itKnightEpithets = [
    "il Valoroso", "il Forte", "il Coraggioso", "il Giusto", "il Grande", "il Nobile", "il Saggio", "il Temerario",
    "del Lago", "della Torre", "della Croce"
];

// Polish Names (Medieval Kingdom of Poland era)
export const plPeasantNames = [
    "Jan", "Piotr", "Stanisław", "Wojciech", "Kazimierz", "Tomasz", "Maciej", "Jakub", "Paweł", "Mikołaj",
    "Anna", "Katarzyna", "Małgorzata", "Jadwiga", "Barbara", "Zofia", "Dorota", "Elżbieta", "Agnieszka", "Helena"
];

export const plPeasantSurnames = [
    "Kowal", "Młynarz", "Piekarz", "Cieśla", "Tkacz", "Pasterz", "Rybak", "Szewc", "Garncarz", "Krawiec"
];

export const plNobleNames = [
    "Kazimierz", "Bolesław", "Władysław", "Mieszko", "Zygmunt", "Jan", "Stefan", "Stanisław", "Leszek", "Konrad",
    "Jadwiga", "Bona", "Anna", "Elżbieta", "Barbara", "Zofia", "Aldona", "Ryksa", "Agnieszka", "Dobrawa"
];

export const plNobleSurnames = [
    "Piast", "Jagiełło", "Korwin", "Leliwa", "Topór", "Jastrzębiec", "Rawicz", "Gryf", "Łabędź", "Ogończyk"
];

export const plKnightTitles = [
    "Rycerz", "Pan"
];

export const plKnightEpithets = [
    "Waleczny", "Mężny", "Dzielny", "Sprawiedliwy", "Wielki", "Szlachetny", "Mądry", "Żelazny",
    "z Krakowa", "z Poznania", "z Gniezna"
];

// Dutch Names (Medieval Low Countries era)
export const nlPeasantNames = [
    "Jan", "Pieter", "Willem", "Hendrik", "Cornelis", "Dirk", "Gerrit", "Jacobus", "Frederik", "Adriaan",
    "Maria", "Anna", "Catharina", "Elisabeth", "Margaretha", "Johanna", "Cornelia", "Wilhelmina", "Geertruida", "Jacoba"
];

export const nlPeasantSurnames = [
    "Smid", "Molenaar", "Bakker", "Timmerman", "Wever", "Visser", "Schoenmaker", "Pottenbakker", "Kleermaker", "Herder"
];

export const nlNobleNames = [
    "Willem", "Floris", "Dirk", "Jan", "Philips", "Karel", "Hendrik", "Godfried", "Boudewijn", "Reinoud",
    "Jacoba", "Maria", "Johanna", "Margaretha", "Elisabeth", "Ada", "Aleid", "Machteld", "Clementia", "Sophia"
];

export const nlNobleSurnames = [
    "van Oranje", "van Holland", "van Gelre", "van Brabant", "van Vlaanderen", "van Henegouwen", "van Limburg", "van Luxemburg", "van Nassau", "van Egmond"
];

export const nlKnightTitles = [
    "Ridder", "Heer"
];

export const nlKnightEpithets = [
    "de Dappere", "de Stoute", "de Sterke", "de Rechtvaardige", "de Grote", "de Edele", "de Wijze", "de IJzeren",
    "van het Meer", "van de Toren", "van het Kruis"
];
